module.exports = __webpack_public_path__ + "static/media/add-item.9d19f81c.png";